import { TextButton, useModal } from '@shape-ds/components';
import AbleToOperateModal from './Modal';
import './Tag.scss';
import { useTranslation } from 'react-i18next';
import { formatStringToBoolean } from 'utils/formatStringToBoolean';
import { AbleToOperateTagProps } from './Tag';

enum AbleToOperateState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface AbleToOperateProps extends AbleToOperateTagProps {
  value?: boolean;
  handleChange?: (value: boolean) => void;
}

export const AbleToOperate = ({ readOnly = false, value, handleChange }: AbleToOperateProps) => {
  const { t } = useTranslation();
  const { openModal } = useModal();

  if (value === undefined) return null;

  const tagName = formatStringToBoolean(value)
    ? AbleToOperateState.ACTIVE
    : AbleToOperateState.INACTIVE;

  return (
    <div className="able-to-operate">
      <TextButton
        className={`able-to-operate-button ${tagName} ${readOnly ? 'readonly' : ''}`}
        onClick={() =>
          !readOnly &&
          openModal(
            <AbleToOperateModal
              ableToOperate={value}
              handleChange={handleChange ?? (() => undefined)}
            />,
            {
              width: '520px',
            },
          )
        }
      >
        {t(`case:ableToOperate.tag.${tagName}`)}
      </TextButton>
    </div>
  );
};
